import { useState, useCallback } from 'react';
import { SmsService } from '../services/smsService';

/**
 * React hook for sending SMS
 * @returns {Object} - Hook state and methods
 */
export function useSms() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const sendSms = useCallback(async (message, numbers, transactionId) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await SmsService.sendSms(message, numbers, transactionId);
      setResult(response);
      return response;
    } catch (e) {
      const errorMessage = e.message || String(e);
      setError(errorMessage);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  const sendWelcomeSms = useCallback(async (submission) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await SmsService.sendWelcomeSms(submission);
      setResult(response);
      return response;
    } catch (e) {
      const errorMessage = e.message || String(e);
      setError(errorMessage);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { sendSms, sendWelcomeSms, loading, result, error };
}

export default useSms;
